import { render, staticRenderFns } from "./ReportDesktopMoreWorkerItems.vue?vue&type=template&id=9ae6ac06"
import script from "./ReportDesktopMoreWorkerItems.vue?vue&type=script&lang=js"
export * from "./ReportDesktopMoreWorkerItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports